import { useQuery } from "@tanstack/react-query";
import getSecuredStatementPdf from "../services/getSecuredStatementPdf";
import { useConfig } from "./useConfig";
import getStatementPdfQueryKey from "../helpers/getStatementPdfQueryKey";
var useStatementPdfQuery = function (_a) {
    var accountId = _a.accountId, statementDate = _a.statementDate, statementInsert = _a.statementInsert;
    var mfeConfig = useConfig();
    return useQuery({
        queryKey: getStatementPdfQueryKey({
            accountId: accountId,
            statementDate: statementDate,
            statementInsert: statementInsert,
        }),
        queryFn: function () {
            return getSecuredStatementPdf({
                mfeConfig: mfeConfig,
                accountId: accountId,
                statementDate: statementDate,
                statementInsert: statementInsert,
            });
        },
    });
};
export default useStatementPdfQuery;
